import React, { Component } from 'react'
import _ from 'lodash'

import { fileHistoryConstants } from '../constants/fileHistoryConstants'
import FileHistoryTable from './FileHistoryTable'
import FileHistoryHeader from './FileHistoryHeader'
import { fetchFileHistory } from '../api/request'
import { getFileName } from '../helpers/fileHistory'
import { sortFiles } from '../helper'

class RenderFileHistory extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      errorMessage: null,
      sortKey: 'timestamp',
      sortOrder: 'descending',
      isLoading: true,
      fileHistory: null,
      timeOffsetIdx: 0,
      showRecordsFrom: 0,
    }
  }

  updateFileHistory = () => {
    const { showFileHistoryForItem } = this.props
    const { showRecordsFrom, timeOffsetIdx, fileHistory } = this.state

    if (_.get(fileHistory, 'userName', '') === '')
      this.setState({ fileHistory: null })

    this.setState({ isLoading: true, errorMessage: null })

    const timestamp = new Date()
    timestamp.setDate(
      timestamp.getDate() -
        fileHistoryConstants.TimestampOffsets[timeOffsetIdx].value,
    )

    const params = {
      from: showRecordsFrom,
      size: fileHistoryConstants.MaxRows,
      timestamp: timestamp.toISOString(),
      fileType: showFileHistoryForItem.fileType,
    }
    const path = showFileHistoryForItem.path

    fetchFileHistory(path, params)
      .then(res => {
        if (res.status === 200) {
          const rawFileHistory = JSON.parse(res.text)
          this.setState({
            isLoading: false,
            fileHistory: {
              ...rawFileHistory,
              results: this.getTrackingResults(rawFileHistory),
            },
          })
        } else {
          this.fetchFileHistoryError(res, fileHistory)
        }
      })
      .catch(err => {
        this.fetchFileHistoryError(err, fileHistory)
      })
  }

  getTrackingResults = rawFileHistory => {
    return _.get(rawFileHistory, 'results', []).map(result => {
      if (_.has(result, 'path')) result.fileName = getFileName(result.path)
      if (result.optype === 'mkdir') result.optype = 'create folder'
      return result
    })
  }

  fetchFileHistoryError = (res, fileHistory) => {
    if (_.isNull(fileHistory)) {
      fileHistory = {}
      fileHistory.results = []
      fileHistory.total = 0
      fileHistory.userName = ''
      fileHistory.userType = ''
    }
    this.setState({ isLoading: false, fileHistory })
    this.setErrorMessage(res)
  }

  sortFileHistory = key => {
    const { fileHistory, sortOrder } = this.state

    const newSortOrder = sortOrder === 'descending' ? 'ascending' : 'descending'
    const sortedResults = sortFiles(
      _.get(fileHistory, 'results', []),
      key,
      newSortOrder.substring(0, newSortOrder.length - 6),
    )

    this.setState({
      sortKey: key,
      sortOrder: newSortOrder,
      fileHistory: {
        ...fileHistory,
        results: sortedResults,
      },
    })
  }

  setShowRecordsFrom = showRecordsFrom => this.setState({ showRecordsFrom })

  setTimeOffsetIdx = timeOffsetIdx => this.setState({ timeOffsetIdx })

  setErrorMessage = error => {
    const {
      constructErrorMessage,
      closeFileHistoryBox,
      showFileHistoryForItem,
    } = this.props
    const errorMessage = constructErrorMessage(
      error,
      showFileHistoryForItem,
      'track',
      false,
    )

    if (error.status === 401) {
      closeFileHistoryBox()
    }
    this.setState({ errorMessage: errorMessage.msg })
  }

  componentDidMount() {
    this.updateFileHistory()
  }

  componentDidUpdate(_prevProps, prevState) {
    const { showRecordsFrom, timeOffsetIdx } = this.state
    if (
      prevState.showRecordsFrom !== showRecordsFrom ||
      prevState.timeOffsetIdx !== timeOffsetIdx
    ) {
      this.updateFileHistory()
    }
  }

  renderErrorMessage = errorMessage => {
    return (
      <div
        className={`ppvx_alert ppvx_alert--type_error w-75 overlay__file-history--alertbox`}
        role="alert"
      >
        {errorMessage}
      </div>
    )
  }

  render() {
    const { errorMessage } = this.state
    const { closeFileHistoryBox, showFileHistoryForItem } = this.props
    const {
      sortFileHistory,
      setTimeOffsetIdx,
      setShowRecordsFrom,
      renderErrorMessage,
    } = this

    return (
      <div className="overlay__container--file-history overlay__container">
        <div className="overlay__content">
          <div className="overlay__action-close" onClick={closeFileHistoryBox}>
            <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-close" />
          </div>
          <div className="overlay__section">
            <FileHistoryHeader
              {...{
                ...this.state,
                setTimeOffsetIdx,
                showFileHistoryForItem,
              }}
            />
            {errorMessage ? renderErrorMessage(errorMessage) : ''}
            <FileHistoryTable
              {...{
                ...this.state,
                fileType: showFileHistoryForItem.fileType,
                sortFileHistory,
                setShowRecordsFrom,
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default RenderFileHistory
